module.exports = __webpack_public_path__ + "static/media/calendar.f13c7bf3.svg";